import { render, staticRenderFns } from "./MOrganizationDetail.vue?vue&type=template&id=445866a8&"
import script from "./MOrganizationDetail.vue?vue&type=script&lang=ts&"
export * from "./MOrganizationDetail.vue?vue&type=script&lang=ts&"
import style0 from "./MOrganizationDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports